import { PaginatorTemplateOptions } from 'primereact/paginator';
import React, { useEffect, useState } from 'react';
import { Column } from '../Column';
import { ColumnGroup } from '../Column-group';
import { Paginator } from '../Paginator';
import { Row } from '../Row';
import { ISmartProps } from './types';
import { View } from './view';

export { Column, Row, ColumnGroup };

export type DataTreeProps = Omit<ISmartProps, 'css'>;

export const DataTree = React.forwardRef((props: DataTreeProps, ref: any) => {
	const { value, rowsPerPage = 5, alwaysShowPaginator, paginator, paginatorTemplate = 'GoToLabel', ...rest } = props;

	const [firstPage, setFirstPage] = useState<number>(0);
	const [customRows, setCustomRows] = useState(rowsPerPage);
	const [currentPage, setCurrentPage] = useState<number | undefined>(1);
	const [data, setData] = useState<any[]>([]);
	const [totalFilteredRecords, setFilteredTotalRecords] = useState<number>(0);

	const getPageNumber = (inputNumber: any, totalPages: any) => {
		if (isNaN(parseInt(inputNumber))) return;

		if (inputNumber <= 0) return 1;

		if (parseInt(inputNumber) > totalPages) return totalPages;

		return inputNumber;
	};

	const handleChangeCurrentPage = (page: any) => {
		const newPage = paginatorTemplate === 'Toolbar' ? page?.[0]?.id : page;
		const pageNumber = getPageNumber(newPage, Math.ceil(data.length / customRows));

		setCurrentPage(pageNumber);
	};

	const onCustomPageChange = (event: any) => {
		setFirstPage(event.first);
		setCustomRows(event.rows);
		setCurrentPage(event.page + 1);
	};

	useEffect(() => {
		setData(
			value && value.length
				? value.map(item => {
						return {
							...item,
							toEdit: false,
						};
				  })
				: [],
		);
	}, [value]);

	// This is needed in order to get the total number of records in the DataTree
	const ItemsLabel: PaginatorTemplateOptions = {
		layout: 'CurrentPageReport',
		CurrentPageReport: (options: any) => {
			const { totalRecords } = options;

			if (totalRecords !== totalFilteredRecords) {
				// Do not remove setTimeout. It is needed in order to make setState synchronous
				setTimeout(() => setFilteredTotalRecords(totalRecords), 0);
			}

			return <></>;
		},
		FirstPageLink: undefined,
		PrevPageLink: undefined,
		PageLinks: undefined,
		NextPageLink: undefined,
		LastPageLink: undefined,
		RowsPerPageDropdown: undefined,
		JumpToPageInput: undefined,
	};

	const page = paginatorTemplate === 'Toolbar' ? [{ label: currentPage, id: currentPage }] : currentPage;
	const showPaginator = alwaysShowPaginator || customRows < totalFilteredRecords;

	return (
		<div>
			<View
				rootref={ref}
				paginatorTemplate={paginator ? ItemsLabel : undefined}
				rows={customRows}
				onPage={() => {}}
				first={firstPage}
				paginator={paginator}
				value={value}
				{...rest}
			/>

			{paginator && !!value?.length && showPaginator && (
				<Paginator
					paginatorTemplate={paginatorTemplate}
					first={firstPage}
					page={page}
					rows={customRows}
					totalRecords={totalFilteredRecords}
					setCurrentPage={handleChangeCurrentPage}
					setCustomFirst={setFirstPage}
					onPageChange={onCustomPageChange}
				/>
			)}
		</div>
	);
});
